var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElliptical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:none;stroke:#29384F;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#CDCCCC;}\n\t.st3{fill:#29384F;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#FFD881;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.63,183.34c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C28.34,149.04,62.94,183.34,105.63,183.34"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "121.07,136.94 131.03,118.93 112.19,74.99 120.87,58.18  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.67,131.35L140.67,131.35c0-17.8-18.74-29.38-34.66-21.41l-18.34,9.18c-6.47,3.24-10.55,9.85-10.55,17.08 v0c0,10.55,8.55,19.1,19.1,19.1h20.51C129.95,155.29,140.67,144.57,140.67,131.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.75,121.59h19.05c1.73,0,3.13,1.4,3.13,3.13s-1.4,3.13-3.13,3.13H53.75c-1.73,0-3.13-1.4-3.13-3.13 S52.02,121.59,53.75,121.59z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 117.81,
    cy: 131.33,
    r: 14.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 93.03,
    cy: 136.94,
    r: 6.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.64,140.78l-30.6-13.09c-1.64-0.56-2.51-2.34-1.95-3.98c0.56-1.64,2.34-2.51,3.98-1.95l30.6,13.09 c1.64,0.56,2.51,2.34,1.95,3.98C95.06,140.47,93.28,141.34,91.64,140.78z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "117.81,131.91 134.06,119.27 134.06,71.47 148.65,59.44  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M99.97,92.3c0,0.03-0.02,0.06-0.06,0.06l0,0H99.8c-0.03,0-0.05-0.03-0.05-0.06c0-0.04,0.02-0.06,0.05-0.06h0.11 C99.94,92.24,99.97,92.26,99.97,92.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElliptical);
export default __webpack_public_path__ + "static/media/Elliptical.0d7a9fc7f82634443431330b8bee9239.svg";
export { ForwardRef as ReactComponent };